import "./PastVisitRecordDoctorView.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faDownload,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
// import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";

import CircularLoading from "../loading/Loading";
import BasicDatePicker from "./Date-picker";
import { toast } from "react-toastify";

import PastVisitGrowthChat from "./PastVisitGrowthChat";
import { ANSWERSTATE, questions } from "../util/mchatQuestions";
import axios from "axios";
import TdscViewer from "./TdscViewer";
import CountdownMessage from "./CountDown";
import { useNavigate } from "react-router-dom";
import RenderPdf from "./ui/RenderPdf.jsx";

const PastVisitRecordDoctorView = ({
  id,
  docId,
  patientName,
  currentAge,
  setVisitData,
  setIsSickVisit,
  isparent = false,
}) => {
  const url = process.env.REACT_APP_BACKEND_URL;
  const [visitRecords, setVisitRecords] = useState([]);
  const [searchStartDate, setSearchStartDate] = useState("");
  const [searchEndDate, setSearchEndDate] = useState("");
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [milestones, setMilestones] = useState([]);
  const [vaccines, setVaccines] = useState([]);
  const [answers, setAnswers] = useState(ANSWERSTATE);
  const [mchatScore, setMchatScore] = useState(null);
  const [mchatStatus, setMchatStatus] = useState(null);
  const token = localStorage.getItem("s2stoken");
  const [downloading, setDownloading] = useState({
    download: false,
    index: null,
  });
  const [downloadAvailable, setDownloadAvailable] = useState(false);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 750);

  dayjs.extend(utc);

  console.log(currentAge);

  function handleEditRecord(data) {
    console.log("passing visit data", data);
    setVisitData({ ...data });
    if (data?.reason_for_visit) {
      setIsSickVisit(true);
    }
  }
  const formatDate = (dateString) => {
    return dayjs(dateString).format("YYYY-MM-DD HH:mm");
  };
  const mchatTableData = questions.map((q) => {
    // Retrieve the answer (or use a fallback text)
    const answer = answers[`q${q.id}`] || "";
    // Combine question number, text, and example (if available)
    let heading = `Q${q.id}. ${q.question}`;
    if (q.example && q.example.trim() !== "") {
      heading += `\nExample: ${q.example}`;
    }
    return { heading, value: answer };
  });
  const sortRecords = (records) => {
    return [...records].sort(
      (a, b) => new Date(b.visit_date_time) - new Date(a.visit_date_time)
    );
  };

  // Filter records based on date range
  const handleSearch = () => {
    if (!searchStartDate || !searchEndDate) {
      toast.warn("Please select both start and end dates.");
      setFilteredRecords(visitRecords);
      return;
    }

    if (!dayjs(searchStartDate).isValid() || !dayjs(searchEndDate).isValid()) {
      toast.error("Invalid date selection. Please choose valid dates.");
      return;
    }

    const adjustedEndDate = dayjs(searchEndDate)
      .endOf("day")
      .format("YYYY-MM-DD HH:mm"); // Include entire end day

    if (searchStartDate > adjustedEndDate)
      return toast.warn("Start date must be before the end date.");

    const filtered = visitRecords.filter((record) => {
      const visitDate = formatDate(record.visit_date_time);
      return visitDate >= searchStartDate && visitDate <= adjustedEndDate;
    });

    setFilteredRecords(sortRecords(filtered));
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 750);
    };

    window.addEventListener("resize", handleResize);

    // Optional: call on mount to ensure correct initial state
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!id || !docId) return;

      setLoading(true);

      try {
        const [visitResponse, vaccineResponse, milestoneResponse] =
          await Promise.all([
            fetch(
              `${url}/api/get_visit_record_by_doctor?id=${id}&docId=${docId}`,
              {
                method: "GET",
                credentials: "include",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
            fetch(
              `${process.env.REACT_APP_BACKEND_URL}/api/get_vaccine_tracker_doctor_view?pediatrician_id=${docId}&patient_id=${id}`,
              {
                method: "GET",
                credentials: "include",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
            fetch(
              `${process.env.REACT_APP_BACKEND_URL}/api/get_milestone_tracker_doctor_view?pediatrician_id=${docId}&patient_id=${id}`,
              {
                method: "GET",
                credentials: "include",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
          ]);

        const [visitData, vaccineData, milestoneData] = await Promise.all([
          visitResponse.json(),
          vaccineResponse.json(),
          milestoneResponse.json(),
        ]);
        if (!visitResponse.ok || visitData.success === false) {
          throw new Error(visitData.message || "Failed to fetch visit data");
        }
        if (!vaccineResponse.ok || vaccineData.success === false) {
          throw new Error(
            vaccineData.message || "Failed to fetch vaccine data"
          );
        }
        if (!milestoneResponse.ok || milestoneData.success === false) {
          throw new Error(
            milestoneData.message || "Failed to fetch milestone data"
          );
        }

        // Process visit records
        setVisitRecords(sortRecords(visitData?.visit_records) || []);
        setFilteredRecords(sortRecords(visitData?.visit_records) || []);
        setSearchStartDate("");
        setSearchEndDate("");

        // Process vaccines
        if (vaccineData.success) {
          setVaccines(
            vaccineData.data
              .filter((vaccine) => vaccine["Whether Taken"] === "yes")
              .map((vaccine) => ({
                ...vaccine,
                "Date When Taken": vaccine["Date When Taken"]
                  .replace(
                    /(\w{3}, \d{2} \w{3} \d{4}) \d{2}:\d{2}:\d{2} GMT/,
                    "$1"
                  )
                  .trim(),
              }))
          );
        } else {
          alert(vaccineData.message);
        }
        // Process milestones
        if (milestoneData.success) {
          setMilestones(
            milestoneData.data
              .filter(
                (milestone) =>
                  (milestone["Milestone Check"] === "yes" &&
                    milestone.Milestone?.trim() &&
                    milestone.Milestone !== "None") ||
                  (milestone["Red Flag Check"] === "yes" &&
                    milestone["Red Flag"]?.trim() &&
                    milestone["Red Flag"] !== "None")
              )
              .map((milestone) => ({
                Milestone:
                  milestone["Milestone Check"] === "yes"
                    ? milestone.Milestone.trim()
                    : "",
                "Red Flag":
                  milestone["Red Flag Check"] === "yes"
                    ? milestone["Red Flag"].trim()
                    : "",
              }))
          );
        } else {
          alert(milestoneData.message);
        }
        // console.log(visitData);
      } catch (error) {
        if (error?.message === "Token has expired") {
          localStorage.removeItem("s2stoken");
          navigate("/");
        }
        console.error("Error fetching data:", error);
        alert("Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, docId]);
  useEffect(() => {
    const fetchMchat = async () => {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/get_mchat`;
      try {
        const res = await axios.get(url, {
          params: {
            id: id,
            docId: docId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("The API Response is : ", res.data.mchat);

        const ans = res.data.mchat;
        setMchatScore(ans?.mchat_score);
        setMchatStatus(ans?.mchat_status);

        setAnswers({
          q0: ans.q0,
          q1: ans.q1,
          q2: ans.q2,
          q3: ans.q3,
          q4: ans.q4,
          q5: ans.q5,
          q6: ans.q6,
          q7: ans.q7,
          q8: ans.q8,
          q9: ans.q9,
          q10: ans.q10,
          q11: ans.q11,
          q12: ans.q12,
          q13: ans.q13,
          q14: ans.q14,
          q15: ans.q15,
          q16: ans.q16,
          q17: ans.q17,
          q18: ans.q18,
          q19: ans.q19,
          q20: ans.q20,
        });
      } catch (error) {
        if (error?.message === "Token has expired") {
          localStorage.removeItem("s2stoken");
          navigate("/");
        }
        console.log("Error fetching MCHAT data", error);
      }
    };

    fetchMchat();
  }, []);

  console.log(
    "filter records",
    filteredRecords,
    visitRecords,
    milestones,
    vaccines
  );

  const recordLength = visitRecords.length || 0;
  const delayTime = recordLength * 5;

  function smoothScrollToBottom(container, duration) {
    const start = container.scrollTop;
    const end = container.scrollHeight - container.clientHeight;
    const distance = end - start;

    let startTime = null;

    function scrollStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percent = Math.min(progress / duration, 1); // Clamp between 0–1
      container.scrollTop = start + distance * percent;

      if (progress < duration) {
        requestAnimationFrame(scrollStep);
      }
    }

    requestAnimationFrame(scrollStep);
  }

  useEffect(() => {
    const container = document.querySelector(".render-pdf-scroll");
    const scrollTime = (visitRecords.length * 5) * 1000; // Convert to milliseconds
    if (container) {
      smoothScrollToBottom(container, scrollTime);
    }
  }, [visitRecords]);

  if (loading) {
    return <CircularLoading />;
  }
  const injectChartsToPDF = async (index) => {
    const pdfContainer = document.getElementById(`pdf-content-${index}`);
    if (!pdfContainer) return;

    const chartMap = [
      { id: "weight-chart" },
      { id: "height-chart" },
      { id: "head-circ-chart" },
      { id: "weight-height-chart" },
    ];

    chartMap.forEach(({ id }) => {
      const sourceCanvas = document.getElementById(id);
      const target = document.querySelector(`[data-chart-id="${id}-${index}"]`);
      if (sourceCanvas && target) {
        const img = document.createElement("img");
        img.src = sourceCanvas.toDataURL("image/png");
        img.style.width = "100%";
        img.style.marginBottom = "10px";
        target.innerHTML = "";
        target.appendChild(img);
      }
    });

    if (isMobile) {
      const sourceEl = document.querySelector(".tdscMobileView");
      const targetEl = pdfContainer.querySelector(
        `.pdfTdscMobileView-${index}`
      );

      if (sourceEl && targetEl) {
        const canvas = await html2canvas(sourceEl, {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        });

        const img = document.createElement("img");
        img.src = canvas.toDataURL("image/png");
        img.style.width = "100%";
        img.style.marginBottom = "10px";
        targetEl.innerHTML = "";
        targetEl.appendChild(img);
      }
    } else {
      const canvas = document.querySelector(".tdscDesktopViewpdf canvas");
      const target = pdfContainer.querySelector(".tdscDesktopViewpdf");
      if (canvas && target) {
        const img = document.createElement("img");
        img.src = canvas.toDataURL("image/png");
        img.style.width = "100%";
        img.style.marginBottom = "10px";
        target.innerHTML = "";
        target.appendChild(img);
      }
    }
  };

  const flushDomUpdates = async () => {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        setTimeout(resolve, 500); // Wait one more frame (~200ms)
      });
    });
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const generateHTML2PDF = async (index) => {
    setDownloading({ download: true, index });

    await injectChartsToPDF(index); // Wait for chart rendering

    await delay(300); // slight delay to let DOM settle
    await flushDomUpdates();
    await delay(500); // slight delay to let DOM settle
    await flushDomUpdates();
    await delay(300); // slight delay to let DOM settle

    const element = document.getElementById(`pdf-content-${index}`);
    if (!element) return;

    const opt = {
      margin: 0.3,
      filename: `Visit_Record_${patientName}_${index + 1}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      pagebreak: { mode: ["css", "legacy"] },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    await html2pdf().set(opt).from(element).save();

    setDownloading({ download: false, index: null });
  };

  return (
    <>
      {visitRecords && (
        <div className="pastvisit-record-container">
          <CountdownMessage
            setDownloadAvailable={setDownloadAvailable}
            countValue={delayTime}
          />
          <h2>Past Visit Records</h2>
          <div className="visit-search-container">
            <p>Search By Date Range</p>
            <div className="date-container">
              <div>
                <span>From</span>
                <span>
                  <BasicDatePicker
                    onChange={(date) =>
                      setSearchStartDate(date ? date.format("YYYY-MM-DD") : "")
                    }
                    value={searchStartDate ? dayjs(searchStartDate) : null}
                    sx={{ width: "200px" }}
                    style={{ height: "35px" }}
                  />
                </span>{" "}
              </div>
              <div>
                <span>To</span>
                <span>
                  <BasicDatePicker
                    onChange={(date) =>
                      setSearchEndDate(date ? date.format("YYYY-MM-DD") : "")
                    }
                    value={searchEndDate ? dayjs(searchEndDate) : null}
                    sx={{ width: "200px" }}
                    style={{ height: "35px" }}
                  />
                </span>
              </div>
              <button className="visit-search" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>
          <div className="pastvisit-record">
            <div className="pastvisit-record-heading">
              <p>Visit Date</p> <p>Reason For Visit</p>
              <p>Actions</p>
            </div>
            {filteredRecords.length > 0 ? (
              filteredRecords.map((data, i) => (
                <div key={i} className="record-container">
                  <p className="visitrecord-date">
                    {dayjs.utc(data.visit_date_time).format("DD MMM YYYY")}
                  </p>
                  <p>{data.reason_for_visit || "Wellness Check"}</p>
                  <div className="visit-record-buttons">
                    <button
                      className={!downloadAvailable ? "pdf-disabled" : ""}
                      disabled={downloading.download || !downloadAvailable}
                      onClick={() => generateHTML2PDF(i)}
                    >
                      {!downloadAvailable ? (
                        <FontAwesomeIcon icon={faClock} />
                      ) : downloading?.download && downloading?.index === i ? (
                        <FontAwesomeIcon icon={faSpinner} spin size="1x" />
                      ) : (
                        <FontAwesomeIcon icon={faDownload} />
                      )}
                      Download
                    </button>
                    {!isparent && (
                      <button onClick={() => handleEditRecord(data)}>
                        Edit
                      </button>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p>No records found.</p>
            )}
          </div>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "200px",
              overflow: "auto",
              marginBottom: "60px",
            }}
          >
            {/* Overlay Div */}
            <div
              style={{
                position: "sticky",
                zIndex: "1000",
                backgroundColor: "#ffffff",
                inset: 0,
                width: "100%",
                height: "100%",
              }}
            ></div>

            {/* Chart Component */}
            <TdscViewer
              pediatricianId={docId}
              patientId={id}
              currentAge={currentAge}
              forPdf={true}
            />
          </div>
          {filteredRecords.length > 0 && <p>processing...</p>}
          <div
            style={{
              position: "relative",
              height: "20px",
              overflow: "auto",
              scrollBehavior: "auto",
              willChange: "scroll-position",
            }}
            className="render-pdf-scroll"
          >
            {filteredRecords.length > 0 &&
              filteredRecords.map((data, i) => (
                <RenderPdf
                  key={i}
                  data={data}
                  index={i}
                  milestones={milestones}
                  vaccines={vaccines}
                  patientName={patientName}
                  isMobile={isMobile}
                  mchatScore={mchatScore}
                  mchatStatus={mchatStatus}
                  mchatTableData={mchatTableData}
                />
              ))}
          </div>

          <div style={{ position: "absolute", left: "-1299px" }}>
            <PastVisitGrowthChat childId={id} />
          </div>
        </div>
      )}
    </>
  );
};
export default PastVisitRecordDoctorView;
